export default [
  {  path: '/notfound',  component: () => import('./components/NotFound.vue')},
  {  path: '/home',  component: () => import('./components/page/home.vue')},

  {  path: '/user',  component: () => import('./components/page/user/userPage.vue')},
  {  path: '/userprofile/:id', component: ()  => import('./components/page/user/profilePage.vue'),props: true},

  {  path: '/permission',  component: () => import('./components/page/permission/PermPage.vue')},

  {  path: '/ad',  component: () => import('./components/page/AdPage.vue')},

  {  path: '/pay',  component: () => import('./components/page/PayPage.vue')},
  {  path: '/pay/:id', component: ()  => import('./components/page/PayPage.vue'),props: true},


    ];